import type { AuthUser } from '@es-tools/shared';

// Presentation defaults only. Never use these preferences to grant or revoke
// data access: the existing route and API entitlement checks still apply.
const DASHBOARD_ONLY_EMAILS = new Set(['benjamin@mengotomars.com']);

export const usesSimpleDataView = (user: AuthUser | null | undefined): boolean =>
  Boolean(user && user.identityType !== 'vendor' && user.appEntitlements?.source !== 'vendor-access'
    && DASHBOARD_ONLY_EMAILS.has(user.email.trim().toLowerCase()));

export const simpleDataRedirect = (user: AuthUser | null | undefined, pathname: string): string | null =>
  usesSimpleDataView(user) && /^\/data(?:\/|$)/.test(pathname)
    && !/^\/data\/dashboards(?:\/[a-z_]+)?\/?$/.test(pathname)
    ? '/data/dashboards' : null;
